module.exports = __webpack_public_path__ + "static/img/18.99530150.png";